//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { StudentDisplayItem } from './StudentDisplayItem';
import { TeacherNameDisplayItem } from './TeacherNameDisplayItem';
import { PracticeLogAttachmentDisplayItem } from './PracticeLogAttachmentDisplayItem';

export class PracticeLogDisplayItem extends ItemBase {
    ID: string | null = null;
    Date: string = "1970-01-01T00:00:00";
    Duration: number = 0;
    HasAttachments: boolean = false;
    Note: string | null = null;
    StudentID: string | null = null;
    Student: StudentDisplayItem | null = null;
    AssignmentName: string | null = null;
    TeacherID: string | null = null;
    Teacher: TeacherNameDisplayItem | null = null;
    FeedbackStudentNote: string | null = null;
    FeedbackParentNote: string | null = null;
    FeedbackPrivateNote: string | null = null;
    HasFeedback: boolean = false;
    Attachments: PracticeLogAttachmentDisplayItem[] = [];

    constructor(initializer?: Partial<PracticeLogDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PracticeLogDisplayItem";
}
